import GlobalAxios from "../axios/axios-config";
import { ICheckInResponse, ICheckInTriageParams } from "../models/check-in";
import {
  ICreateTriages,
  IGetSearchParams,
  IGetTriages,
} from "../models/triage";

const BASE_URL =
  process.env.REACT_APP_CALENDAR + "/api/v1/TriageEmergencyDepartment";
const BASE_URL_CHECKIN =
  process.env.REACT_APP_CALENDAR + "/api/v1/tasy/TriageCheckin";

export class TriageEmergencyDepartment {
  public static create = (item: ICreateTriages) => {
    return GlobalAxios.post(BASE_URL, item);
  };

  public static getTriages = (params?: IGetSearchParams) => {
    return GlobalAxios.get<IGetTriages>(BASE_URL, { params });
  };
}

export const checkInTriage = (params: ICheckInTriageParams) => {
  return GlobalAxios.put<ICheckInResponse>(BASE_URL_CHECKIN, params);
};

export default TriageEmergencyDepartment;
